// stores
import { useAuthStore } from '@/stores/AuthStore/AuthStore'

// services
import LicenseApiService from './License.api'
import { V2 } from './LicenseApi/V2'
import { HttpClient } from './LicenseApi/http-client'

export class LicenseApiServiceSingleton {
  private static _licenseApiService: LicenseApiService | undefined = undefined
  private static _licenseApiServiceV2: V2<unknown> | undefined = undefined

  public static readonly getLicenseApiServiceInstance = async () => {
    const authStore = useAuthStore()
    await authStore.update().then(() => {
      if (this._licenseApiService === undefined) {
        this._licenseApiService = new LicenseApiService(authStore.authToken)
      }
    })

    return this._licenseApiService
  }
  public static readonly getLicenseApiServiceInstanceV2 = async () => {
    if (!this._licenseApiServiceV2) {
      const authStore = useAuthStore()
      await authStore.update()

      const licenseApiServiceUrl = `https://license.svc.${authStore.dc}`

      this._licenseApiServiceV2 = new V2(new HttpClient(
        {
          secure: true,
          baseURL: licenseApiServiceUrl,
          headers: {
            Authorization: `Bearer ${authStore.authToken}`,
            'Content-Type': 'application/json',
          },
        }))
    }
    return this._licenseApiServiceV2
  }
}
